export default __webpack_public_path__ + "static/media/request.dda25e8b.svg";